<template>
  <div class="d-flex justify-center">
    <v-tooltip top v-if="eligible">
      <template #activator="{ on, attrs }">
        <v-btn icon color="secondary" v-bind="attrs" v-on="on" @click="trigger">
          <v-icon size="22">mdi-flask-outline</v-icon>
        </v-btn>
      </template>
      <span>Simulate Gate In for this container</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  computed: {
    eligible() {
      const row = this.params.data || {};
      return !!row.voyage_id && row.status !== "Completed" && row.status !== "Cancelled";
    },
  },
  methods: {
    trigger() {
      this.params.context.parentComponent.openSimulateGateIn(this.params.data);
    },
  },
};
</script>
